const prodConfig = {
  api: 'https://juicysuite.app/member/api/',
};

export default prodConfig;
